type AddressType = {
	addressLine1: string;
	addressLine2: string;
	city: string;
	postalCode: string;
	state: string;
};

export const renderAddress = (addressObj: AddressType) => {
	return `${addressObj.addressLine1}, ${addressObj.addressLine2 ? addressObj.addressLine2 : ""} ${
		addressObj.city
	}, ${addressObj.state} ${addressObj.postalCode}`;
};

export { getApiUrl, getReportsUrl } from './apiUrl';
